import http from '../../../../api/http'

function retrieveOnlineJobFairCountListPaging(paramObj) {
    return http.post('/admin/ojf/onlineJobFair/retrieveOnlineJobFairCountListPaging', paramObj)
}

function retrieveAllRecruitmentHallStatusPaging(paramObj) {
    return http.post('admin/ojf/recruitmentHall/retrieveAllRecruitmentHallStatusPaging', paramObj)
}

function retrieveAllRecruitmentHallStatusExcel(paramObj) {
    return http.post('admin/ojf/recruitmentHall/retrieveAllRecruitmentHallStatusExcel', paramObj, {
        responseType: 'blob',
    })
}

function updateCorpJoinState(paramObj) {
    return http.post('admin/ojf/recruitmentHall/updateJoinState', paramObj)
}

function retrieveAllEntryStatusPaging(paramObj) {
    return http.post('admin/ojf/entry/retrieveAllEntryStatusPaging', paramObj)
}

function retrieveAllEntryStatusExcel(paramObj) {
    return http.post('admin/ojf/entry/retrieveAllEntryStatusExcel', paramObj, {
        responseType: 'blob',
    })
}

function updateEntryJoinState(paramObj) {
    return http.post('admin/ojf/entry/updateEntryJoinState', paramObj)
}

function retrieveEntryByOjfIdAndUserId(ojfId, userId) {
    return http.get(`admin/ojf/entry/retrieveEntryByOjfIdAndUserId?ojfId=${ojfId}&userId=${userId}`)
}

export default {
    retrieveOnlineJobFairCountListPaging,
    retrieveAllRecruitmentHallStatusPaging,
    retrieveAllRecruitmentHallStatusExcel,
    updateCorpJoinState,
    retrieveAllEntryStatusPaging,
    retrieveAllEntryStatusExcel,
    updateEntryJoinState,
    retrieveEntryByOjfIdAndUserId
}
